// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import Dialog from '../Dialog';
import Iframe from '../../components/Iframe';

type PropTypes = {|
  formTitle?: string,
  formUrl: string,
  onToggle: boolean => void,
|};

export default (props: PropTypes) => {
  return (
    <Dialog onUpdate={props.onToggle} size="Medium">
      <div className={styles.form}>
        {props.formTitle && <h2 className={styles.formTitle}>{props.formTitle}</h2>}
        <Iframe src={props.formUrl} appliedMinHeight />
      </div>
    </Dialog>
  );
};
